import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import MapIcon from '@domain-group/fe-co-icon/lib/js/map';
import ListIcon from '@domain-group/fe-co-icon/lib/js/list';
import * as styles from './allhomes-listing-view-toggle.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ViewToggle = props => ___EmotionJSX("button", {
  type: "button",
  css: styles.viewToggle,
  onClick: props.onToggle
}, isEqual(props.type, 'map') ? ___EmotionJSX(MapIcon, {
  css: styles.viewToggleIcon
}) : ___EmotionJSX(ListIcon, {
  css: styles.viewToggleIcon
}), ___EmotionJSX("span", {
  css: styles.viewToggleText
}, isEqual(props.type, 'map') ? 'Map view' : 'List view'));
ViewToggle.propTypes = {
  type: PropTypes.oneOf(['map', 'list']).isRequired,
  onToggle: PropTypes.func.isRequired
};
ViewToggle.defaultProps = {};
export default ViewToggle;